module.exports = __webpack_public_path__ + "assets/icons/ic_organization_24px.svg";